import React from 'react'

import { func, string } from 'prop-types'

import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import I18n from 'Pods/Shared/I18n'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

const t = (key, options) => I18n.t(key, { ns: 'rails', ...options })

// Extracted so each chip subscribes only to the slice it cares about - sibling
// toggles don't trigger this row's re-render.
function TechnicalAttributesChip({ chipKey, select, onChange }) {
  const isChecked = useSearchPageStore(select)

  return (
    <FilterChip
      id={`technical-attr-${chipKey}`}
      label={t(`search_page.filters.technical_attributes.${chipKey}`)}
      isChecked={isChecked}
      onChange={onChange}
    />
  )
}

TechnicalAttributesChip.propTypes = {
  chipKey: string.isRequired,
  select: func.isRequired,
  onChange: func.isRequired,
}

export default TechnicalAttributesChip
